/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @emails oncall+relay
 * 
 * @format
 */
'use strict';

var useMemoVariables = require('./useMemoVariables');

var React = require('react');

var _require = require('relay-runtime'),
    createOperationDescriptor = _require.createOperationDescriptor,
    getRequest = _require.getRequest;

var useMemo = React.useMemo;

function useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
  var _useMemoVariables = useMemoVariables(variables),
      memoVariables = _useMemoVariables[0];

  var _useMemoVariables2 = useMemoVariables(cacheConfig || {}),
      memoCacheConfig = _useMemoVariables2[0];

  return useMemo(function () {
    return createOperationDescriptor(getRequest(gqlQuery), memoVariables, memoCacheConfig);
  }, [gqlQuery, memoVariables, memoCacheConfig]);
}

module.exports = useMemoOperationDescriptor;